import _ from 'lodash';
import createTakenError from 'scripts/domain/factories/error/create_taken_error';
import Team from 'models/team';

export default class SaveTeam {
  constructor(context) {
    this.context = context;
  }

  run(teamAttrs) {
    let { name, id, _version } = teamAttrs;

    let validationErrors = this.getValidationErrors({ name, id });
    let existingTeam = this.context.stores.teams.findBy({ id }) || {};
    let team = Team.create({ ...existingTeam, ...teamAttrs, _version: _version + 1 });
    if (id) {
      if (validationErrors.length) {
        this.context.stores.teams.setErrors(id, validationErrors);
        return;
      }

      this.context.stores.teams.setPending(team);
    } else {
      if (validationErrors.length) {
        this.context.stores.teams.setErrorsForNew(validationErrors);
        return;
      }

      this.context.stores.teams.setPendingNew(team);
    }

    this.context.gateways.team.addOrReplace(_.omit(team.toJs(), 'createdBy'));
  }

  getValidationErrors({ name, id }) {
    let teamErrors = Team.getValidationErrors({ name });
    let team = this.context.stores.teams.findBy({ name });

    if (team) {
      if (team.id !== id) {
        teamErrors.push(createTakenError('name', team.name));
      }
    }
    return teamErrors;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/teams/save_team.js